export enum WorkingHoursType {
    Company = 0,
    Department,
    Forklift
}